
import { buildPath } from '@shared/utils';


export const COMMUNITY = {
  path: 'community',
  data: {
    breadcrumb: 'MENU_ADMIN.COMMUNITY',
    icon: 'fa-solid fa-people-group',
    clickable: false,
    openTab: true
  },

  units: {
    path: 'units',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.UNITS',
      icon: 'pi pi-building',
      openTab: true
    },
    list: {
      data: {
        breadcrumb: 'UNIT.LIST_TITLE',
        icon: 'pi pi-building',
        clickable: true
      }
    },
    create: {
      path: buildPath('units', 'new'),
      data: {
        breadcrumb: 'UNIT.CREATE_TITLE',
        icon: 'pi pi-building',
        clickable: true
      }
    },
    edit: {
      path: buildPath('units', ':unitId'),
      data: {
        breadcrumb: 'UNIT.EDIT_TITLE',
        icon: 'pi pi-building',
        clickable: true
      }
    }
  },
  zones: {
    path: 'zones',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.ZONES',
      icon: 'pi pi-map',
      openTab: true
    }
  },
  employees: {
    path: 'employees',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.EMPLOYEES',
      icon: 'fa-regular fa-id-card',
      openTab: true
    }
  },
  councilAdministration: {
    path: 'council',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.COUNCIL_ADMINISTRATION',
      icon: 'pi pi-users',
      openTab: true
    }
  },
  circularsSurveys: {
    path: 'circulars',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.COMMUNICATION_SUB.CIRCULARS_SURVEYS',
      icon: 'fa-solid fa-scroll',
      openTab: true
    }
  },
  chat: {
    path: 'chat',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.COMMUNICATION_SUB.CHAT',
      icon: 'fa-solid fa-message',
      openTab: true
    }
  },
  documentRepository: {
    path: 'documents',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.DOCUMENTS_LEGAL_SUB.DOCUMENT_REPOSITORY',
      icon: 'pi pi-folder-open',
      openTab: true
    }
  },
  legalCompliance: {
    path: 'legal-compliance',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.DOCUMENTS_LEGAL_SUB.LEGAL_COMPLIANCE',
      icon: 'fa-solid fa-scale-balanced',
      openTab: true
    }
  },
  commonAreas: {
    path: 'common-areas',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.COMMON_AREAS',
      icon: 'fa-solid fa-tree-city',
      openTab: true
    }
  },
  visitsSecurity: {
    path: 'visits-security',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.VISITS_SECURITY',
      icon: 'fa-solid fa-person-military-to-person',
      openTab: true
    }
  },
  virtualAssembly: {
    path: 'virtual-assembly',
    data: {
      breadcrumb: 'MENU_ADMIN.COMMUNITY_SUB.VIRTUAL_ASSEMBLY',
      icon: 'fa-solid fa-sitemap',
      openTab: true
    }
  }

};
